const secrets = {

    getRandomKey() {
        var players = ['Messi',
            'Ronaldinho',
            'Pele',
            'Beckenbaur',
            'Maradona',
            'Cruyff',
            'Pique',
            'Umtiti',
            'Busquets',
            'Dembele',
            'Jordi Alba',
            'Pogba',
            'De Gea',
            'Sterling',
            'Ederson',
            'De Bruyne',
            'Kompany',
            'David Silva',
            'Bernardo Silva',
            'Neymar',
            'Cavani',
            'Kimbembe',
            'Thiago Silva',
            'Bale',
            'Courtois',
            'Ramos',
            'Marcelo',
            'Kante',
            'Modric',
            'Benzema',
            'Tony Kroos',
            'Zlatan',
            'Iniesta',
            'Xavi',
            'Pulisic',
            'Jadon Sancho',
            'Reus',
            'Gotze',
            'Salah',
            'Sadio Mane',
            'Firminho',
            'Coutinho',
            'Harry Kane',
            'David Alba',
            'Boateng',
            'Ribery',
            'Van Persie',
            'Thiery Henry',
            'Ronaldo',
            'Dybala',
            'Semedo',
            'Hazard',
            'Mbamppe',
            'Griezmann',
            'Diego Costa',
            'Suarez',
            'David Luiz',
            'Ozil',
            'Aubameyang',
            'Ter Stegen',
            'Rooney',
            'Beckham',
            'Lampard',
            'Lenglet',
            'Puyol',
            'Dani Alvez',
            'Khedira',
            'Isco',
            'Aguero',
            'Fernandinho',
            'Frankie de Jong',
            'Vidal',
            'Rakitic',
            'Asensio',
            'Pickford',
            'Rashford',
            'Martial',
            'Lukaku',
            'Witsel',
            'Nzonzi',
            'Lewandowski',
            'Van Dijk',
            'John Stones',
            'Otamendi',
            'Mendy',
            'Kyle Walker',
            'Laporte',
            'Zidane',
            'Platini',
            'Van Basten',
            'Gundagon',
            'Buffon',
            'Neuer',
            'Pavard',
            'Rabbiot',
            'Payet',
            'Varratti',
            'Odegaard',
            'Matuidi',
            'Ibrahimovic'
        ]

        return players[Math.floor(Math.random() * players.length)];
    }
}

export default secrets;